import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgManagedKubernetes = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-managed-kubernetes';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M4.392 5.011 2.243 6.62v10.76l2.005 1.5c1.103.825 2.072 1.55 2.154 1.61l.149.11.45-.601c.247-.331.443-.607.434-.615L5.59 18.001 3.76 16.63V7.37l1.83-1.371 1.845-1.383c.013-.011-.871-1.218-.889-1.215-.003.001-.973.725-2.154 1.61m12.607-1.01c-.247.331-.443.607-.434.615l1.845 1.383 1.83 1.371v9.26l-1.83 1.371-1.845 1.383c-.009.008.187.284.434.615l.45.601.149-.11c.082-.06 1.051-.785 2.154-1.61l2.005-1.5V6.62l-2.005-1.5c-1.103-.825-2.072-1.55-2.154-1.61l-.149-.11zm-6.888 4.73L8.242 9.82V12l-.001 2.18 1.88 1.095L12 16.369l1.879-1.094 1.88-1.095-.001-2.18V9.82l-1.873-1.09a136 136 0 0 0-1.889-1.089c-.009.001-.857.491-1.885 1.09m3.029 1.303 1.08.631v2.673l-1.11.648-1.11.648-1.11-.648-1.11-.648v-2.673l1.08-.631c.594-.348 1.107-.632 1.14-.632s.546.284 1.14.632"
    })
  }));
});
export default SvgManagedKubernetes;